import React from 'react';
import { Typography } from '@ag1/ui';
import { StudioHotspotImageV2 } from 'shared/studio/StudioHotspotImage';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import { IngredientsList } from 'types/studio/studio';
import styles from './IngredientsListCard.module.scss';

type CardProps = IngredientsList['cards'][number];

export const IngredientsListCard = ({ image, headline, subtitle }: CardProps) => (
  <div className={styles.card} role="button" tabIndex={0}>
    <StudioHotspotImageV2
      className={styles.image}
      image={image}
      sizes={{ xxs: '72px', s: '96px', m: '134px' }}
    />
    <div>
      <Typography
        component="div"
        variant="subtitle"
        size="2"
        color="black-new"
        noPadding
        className={styles.headline}>
        <CustomPortableText value={headline} />
      </Typography>
      <Typography
        component="div"
        variant="portalCaption"
        size="1"
        color="black-new"
        noPadding
        className={styles.subtitle}>
        <CustomPortableText value={subtitle} />
      </Typography>
    </div>
  </div>
);
